import { render } from "./BackArrowSvg.vue?vue&type=template&id=731d040e&bindings={}"
import script from "./BackArrowSvg.vue?vue&type=script&lang=ts"
export * from "./BackArrowSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script